class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.js-recently-viewed-container');
    this.limit = parseInt(this.dataset.limit) || 4;
    this.productId = this.dataset.productId;
    this.sectionId = 'recently-viewed-item'; // The helper section we created
    
    this.init();
  }

  init() {
    if (this.productId) {
      this.addToRecentlyViewed(this.productId);
    }
    this.render();
  }

  getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem('recently_viewed_products')) || [];
    } catch (e) {
      return [];
    }
  }

  addToRecentlyViewed(id) {
    let viewed = this.getRecentlyViewed();
    // Remove if already exists to move it to the front
    viewed = viewed.filter(item => item !== id);
    // Add to front
    viewed.unshift(id);
    // Trim to limit (store a bit more than display limit just in case)
    viewed = viewed.slice(0, 20);
    localStorage.setItem('recently_viewed_products', JSON.stringify(viewed));
  }

  async render() {
    // In the Theme Editor, rely on Liquid placeholders
    if (window.Shopify && window.Shopify.designMode) {
      this.classList.remove('hidden');
      return;
    }

    const viewed = this.getRecentlyViewed();
    // Filter out current product from display if we are on a product page
    const displayIds = viewed.filter(id => id !== this.productId).slice(0, this.limit);

    if (displayIds.length === 0) {
      this.classList.add('hidden');
      return;
    }

    this.classList.remove('hidden');
    
    // Clear container
    this.container.innerHTML = '';

    const requests = displayIds.map(id => this.fetchProductCard(id));
    const responses = await Promise.all(requests);

    responses.forEach(html => {
      if (!html) return;

      const li = document.createElement('li');
      li.className = 'grid__item recently-viewed__item';

      const template = document.createElement('template');
      template.innerHTML = html.trim();

      const cardWrapper = template.content.querySelector('.card-wrapper');
      if (cardWrapper && !cardWrapper.classList.contains('product-card-wrapper')) {
        cardWrapper.classList.add('product-card-wrapper');
      }

      li.appendChild(template.content);
      this.container.appendChild(li);
    });
  }

  async fetchProductCard(handle) {
    try {
      const root = window.Shopify.routes ? window.Shopify.routes.root : '/';
      const url = `${root}products/${handle}?section_id=${this.sectionId}`;
      
      const response = await fetch(url);
      if (!response.ok) throw new Error(response.statusText);
      const text = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const inner = doc.querySelector('.shopify-section');
      return inner ? inner.innerHTML : text;
    } catch (error) {
      console.error('Error fetching recently viewed product:', error);
      return null;
    }
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
